<template>
  <div class="lp">

    <!-- ===== HERO VIDEO ===== -->
    <section class="lp-hero-img">
      <div class="lp-hero-video">
        <video
          ref="heroVideo"
          src="@/assets/1.mp4"
          autoplay
          muted
          loop
          playsinline
          preload="auto"
        ></video>
      </div>
      <img src="@/assets/2.png" alt="르엘 리버파크 센텀" />
    </section>

    <!-- ===== 사업개요 (헤더) ===== -->
    <section class="lp-section lp-sec-head">
      <div class="lp-inner center">
        <span class="lp-eyebrow">— O V E R V I E W —</span>
        <h2 class="lp-section-title">사업개요</h2>

        <div class="ov-stats">
          <div class="ov-stat">
            <span class="ov-stat-num">2,070</span>
            <span class="ov-stat-unit">세대</span>
          </div>
          <span class="ov-stat-div"></span>
          <div class="ov-stat">
            <span class="ov-stat-num">67</span>
            <span class="ov-stat-unit">층</span>
          </div>
        </div>

        <p class="lp-sec-sub">부산의 첫 르엘, 센텀의 정점에 서다</p>
        <div class="lp-gold-line"></div>
      </div>
    </section>

    <!-- ===== 사업개요 (조감도 롤링 배너) ===== -->
    <section class="ov-carousel-sec">
      <div
        class="ov-carousel"
        @touchstart.passive="onOvTouchStart"
        @touchend.passive="onOvTouchEnd">
        <div class="ov-track" :style="{ transform: `translateX(-${ovSlide * 100}%)` }">
          <div class="ov-slide"><img src="@/assets/사업개요1.jpg" alt="르엘 리버파크 센텀 조감도 1" /></div>
          <div class="ov-slide"><img src="@/assets/사업개요2.jpg" alt="르엘 리버파크 센텀 조감도 2" /></div>
          <div class="ov-slide"><img src="@/assets/사업개요3.jpg" alt="르엘 리버파크 센텀 조감도 3" /></div>
        </div>

        <button class="ov-arrow ov-arrow-prev" @click="prevOvSlide" aria-label="이전 조감도">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
        </button>
        <button class="ov-arrow ov-arrow-next" @click="nextOvSlide" aria-label="다음 조감도">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>
        </button>

        <div class="ov-counter">
          <span class="ov-counter-cur">{{ String(ovSlide + 1).padStart(2, '0') }}</span>
          <span class="ov-counter-sep">/</span>
          <span class="ov-counter-total">03</span>
        </div>
      </div>
    </section>

    <!-- ===== 사업개요 (스펙 2칸) ===== -->
    <section class="lp-section lp-overview-table">
      <div class="lp-inner">
        <dl class="ov-specs">
          <div class="ov-spec"><dt>현장명</dt><dd>르엘 리버파크 센텀</dd></div>
          <div class="ov-spec"><dt>사업방식</dt><dd>공공기여 협상방식</dd></div>
          <div class="ov-spec ov-spec-wide"><dt>대지위치</dt><dd>부산광역시 해운대구 재송동 856-6번지 일원</dd></div>
          <div class="ov-spec"><dt>대지면적</dt><dd>46,464㎡</dd></div>
          <div class="ov-spec"><dt>건축면적</dt><dd>20,245.8289㎡</dd></div>
          <div class="ov-spec ov-spec-wide"><dt>건축규모</dt><dd>지하 6층 / 48층(1개동), 67층(5개동)</dd></div>
          <div class="ov-spec ov-spec-wide"><dt>세대수</dt><dd>2,070세대</dd></div>
        </dl>
      </div>
    </section>

    <!-- ===== LOCATION & VALUE (프리미엄) ===== -->
    <section class="lp-section lp-location">
      <div class="lp-inner center">
        <span class="lp-eyebrow light">— P R E M I U M —</span>
        <h2 class="lp-section-title white">
          깊이 있는 삶,<br/>
          <em>선망의 시작</em>
        </h2>
        <div class="lp-gold-line"></div>

        <div class="loc-grid">
          <article class="loc-card" v-for="(it, i) in locationItems" :key="i">
            <div class="loc-card-head">
              <span class="loc-num">0{{ i + 1 }}</span>
              <span class="loc-tag">{{ it.tag }}</span>
            </div>
            <h3 class="loc-en">{{ it.en }}</h3>
            <div class="loc-line"></div>
            <ul class="loc-list">
              <li v-for="(ln, j) in it.lines" :key="j">{{ ln }}</li>
            </ul>
          </article>
        </div>
      </div>
    </section>

    <!-- ===== 로케이션 (입지 헤더) ===== -->
    <section class="lp-section lp-sec-head">
      <div class="lp-inner center">
        <span class="lp-eyebrow">— L O C A T I O N —</span>
        <h2 class="lp-section-title">
          르엘, 기대를 채우다<br/>
          센텀, 여유를 더하다
        </h2>
        <p class="lp-sec-sub">
          청담 · 잠실(예정) · 대치 · 반포 그리고 해운대 센텀에<br/>
          롯데건설의 하이엔드 브랜드, 르엘이 옵니다
        </p>
        <div class="lp-gold-line"></div>
      </div>
    </section>

    <!-- ===== 로케이션 (입지 이미지) ===== -->
    <section class="lp-hero-img">
      <img src="@/assets/입지.jpg" alt="르엘 리버파크 센텀 입지" />
    </section>

    <!-- ===== PLOT PLAN ===== -->
    <section class="lp-section lp-plot">
      <div class="lp-inner center">
        <span class="lp-eyebrow">— P L O T &nbsp; P L A N —</span>
        <h2 class="lp-section-title">
          2,070세대, 6개 동의<br/>
          <em>단일 단지</em> 배치
        </h2>
        <div class="lp-gold-line"></div>

        <p class="plot-lead">
          한 단지 안에서 완결되는 르엘 리버파크 센텀의 <strong>스카이라인</strong>.
        </p>

        <figure class="plot-fig">
          <img class="plot-img" src="@/assets/동호배치도.png" alt="르엘 리버파크 센텀 동호배치도" />
          <img class="plot-img" src="@/assets/동호배치도2.jpg" alt="르엘 리버파크 센텀 동호배치도 2" />
          <figcaption class="plot-cap">※ 본 배치도는 이해를 돕기 위한 자료이며 실제와 다를 수 있습니다.</figcaption>
        </figure>
      </div>
    </section>

    <!-- ===== COMMUNITY (Salon de LEEL) ===== -->
    <section class="lp-section lp-community">
      <div class="lp-inner center">
        <span class="lp-eyebrow light">— S A L O N &nbsp; D E &nbsp; L E E L —</span>
        <h2 class="lp-section-title white">
          살롱 드 르엘,<br/>
          <em>르엘의 소사이어티</em>
        </h2>
        <div class="lp-gold-line"></div>

        <div class="comm-stats">
          <div class="comm-stat"><span class="comm-stat-num">2,070</span><span class="comm-stat-unit">세대</span></div>
          <span class="comm-stat-div"></span>
          <div class="comm-stat"><span class="comm-stat-num">3,300</span><span class="comm-stat-unit">평</span></div>
        </div>

        <p class="comm-lead">
          2,070세대를 아우르는 3,300평 규모의 하이엔드 커뮤니티.<br/>
          매일 마주하는 눈부신 삶의 경험을 모아, 새로운 라이프스타일을 실현합니다.
        </p>
        <p class="comm-note">COMMUNITY · 지상 3층</p>
      </div>

      <!-- 브랜드 영상 -->
      <div class="lp-inner">
        <div class="comm-video">
          <iframe
            src="https://www.youtube.com/embed/BpMYvG6E33w"
            title="르엘 리버파크 센텀 커뮤니티"
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen></iframe>
        </div>
      </div>

      <!-- 커뮤니티 이미지 -->
      <div class="comm-images">
        <img v-if="assetImg('커뮤니티.png')" :src="assetImg('커뮤니티.png')" alt="르엘 리버파크 센텀 커뮤니티" />
        <img v-if="assetImg('커뮤니티2.png')" :src="assetImg('커뮤니티2.png')" alt="르엘 리버파크 센텀 커뮤니티" />
      </div>

      <!-- 시설 카테고리 -->
      <div class="lp-inner">
        <div class="comm-cats">
          <article
            class="comm-cat"
            :class="{ 'comm-cat-wide': commCats.length % 2 === 1 && i === commCats.length - 1 }"
            v-for="(c, i) in commCats" :key="c.cat">
            <span class="comm-cat-name">{{ c.cat }}</span>
            <ul class="comm-cat-list">
              <li v-for="(f, i) in c.items" :key="i">{{ f }}</li>
            </ul>
          </article>
        </div>
      </div>
    </section>

    <!-- ===== UNIT (세대안내) ===== -->
    <section class="lp-section lp-unit">
      <div class="lp-inner center">
        <span class="lp-eyebrow">— U N I T &nbsp; P L A N —</span>
        <h2 class="lp-section-title">세대안내</h2>
        <div class="lp-gold-line"></div>

        <!-- 타입 탭 (가로 스크롤) -->
        <div class="unit-tabs-wrap">
          <div class="unit-tabs">
            <button
              v-for="u in unitList"
              :key="u.id"
              class="unit-tab"
              :class="{ active: activeUnit === u.id }"
              @click="activeUnit = u.id">
              {{ u.id }}
            </button>
          </div>
        </div>

        <!-- 선택 타입 상세 -->
        <transition name="unit-fade" mode="out-in">
          <div class="unit-detail" :key="currentUnit.id">
            <!-- 서브 배너 -->
            <div class="unit-banner">
              <div class="unit-banner-head">
                <span class="unit-area">{{ currentUnit.id }}<span class="unit-area-unit">㎡</span></span>
                <span class="unit-badge">확장형</span>
              </div>
              <p class="unit-supply">
                총 <strong>2,070세대</strong> 중 일반분양 <strong>{{ currentUnit.supply }}세대</strong>
              </p>
            </div>

            <!-- 면적 정보 -->
            <dl class="unit-specs">
              <div class="unit-spec"><dt>전용면적</dt><dd>{{ currentUnit.exclusive }}㎡</dd></div>
              <div class="unit-spec"><dt>주거공용면적</dt><dd>{{ currentUnit.residential }}㎡</dd></div>
              <div class="unit-spec"><dt>기타공용면적</dt><dd>{{ currentUnit.other }}㎡</dd></div>
              <div class="unit-spec"><dt>공급면적</dt><dd>{{ currentUnit.supplyArea }}㎡</dd></div>
              <div class="unit-spec unit-spec-total"><dt>계약면적</dt><dd>{{ currentUnit.contract }}㎡</dd></div>
            </dl>

            <!-- 평면 이미지 2장 -->
            <div class="unit-images">
              <div class="unit-img-slot" v-for="n in 2" :key="n">
                <img
                  v-if="unitImg(currentUnit.id, n)"
                  :src="unitImg(currentUnit.id, n)"
                  :alt="`${currentUnit.id}㎡ 평면 ${n}`"
                  class="unit-img" />
                <div v-else class="unit-img-empty">
                  <span class="unit-img-empty-id">{{ currentUnit.id }}㎡</span>
                  <span class="unit-img-empty-sub">평면 이미지 {{ n }} · 준비 중</span>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </section>

    <!-- ===== SYSTEM (시스템) ===== -->
    <section class="lp-section lp-system">
      <div class="lp-inner center">
        <span class="lp-eyebrow">— S Y S T E M —</span>
        <h2 class="lp-section-title">첨단 시스템</h2>
        <div class="lp-gold-line"></div>

        <div class="sys-grid">
          <article class="sys-card" v-for="s in systemItems" :key="s.title">
            <div class="sys-body">
              <span class="sys-label">{{ s.label }}</span>
              <h3 class="sys-title">
                <span v-if="s.lead" class="sys-lead">{{ s.lead }}</span>
                {{ s.title }}
              </h3>
              <p class="sys-desc">{{ s.desc }}</p>
            </div>
            <div class="sys-icon"><img :src="assetImg(s.icon)" :alt="s.title" /></div>
          </article>
        </div>
      </div>
    </section>

    <!-- ===== RESERVATION CTA ===== -->
    <section class="lp-section lp-cta">
      <div class="lp-inner narrow center">
        <span class="lp-eyebrow light">— R E S E R V A T I O N —</span>
        <h2 class="lp-section-title white">
          <em>초대 받은 분</em>께만<br/>
          열리는 거주의 문
        </h2>
        <div class="lp-gold-line"></div>

        <p class="cta-desc">
          르엘 리버파크 센텀은 <strong>철저한 예약제</strong>로 운영됩니다.<br/>
          상담 전용 라인을 통해 안내드립니다.
        </p>

        <button class="cta-btn" @click="openRegister">
          <span class="cta-btn-en">PRIVATE RESERVATION</span>
          <span class="cta-btn-kr">방문 예약하기</span>
          <span class="cta-btn-arrow">→</span>
        </button>

        <p class="cta-note">
          ※ 본 사이트는 르엘 리버파크 센텀 분양 상담 및 방문 예약 안내 페이지입니다.<br/>
          시행사·시공사의 공식 홈페이지가 아닙니다.
        </p>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'MainView',
  data() {
    return {
      activeUnit: '84',

locationItems: [
        {
          tag: 'HERITAGE', en: 'INFRA PREMIUM',
          lines: [
            '신세계 백화점·벡스코 등 상업·문화·교통을 아우르는 센텀시티의 중심 인프라',
            '부산의 대표적인 부촌, 다양한 예술과 문화를 향유하는 공간',
            '해운대 센텀, 이름만으로도 증명되는 가치',
          ]
        },
        {
          tag: 'EDU PRIDE', en: 'HIGH-END EDU',
          lines: [
            '부산의 경제·문화·교육 1번지, 센텀',
            '당 사업지 반경 1km 내 초·중·고등학교 위치',
            '밀집된 학원가, 뛰어난 교육 환경 속 변하지 않는 자부심',
          ]
        },
        {
          tag: 'TRAFFIC VALUE', en: 'FAST TRAFFIC',
          lines: [
            '좌수영로·수영강변대로·번영로·원동IC',
            '만덕~센텀 지하고속화도로(2026년 개통 예정) 개발',
            '바로 앞 동해선 재송역, 광안대교로 누리는 광역 인프라',
          ]
        },
        {
          tag: 'WATERY NATURE', en: 'HEALING LIFE',
          lines: [
            '해운대 바다, 수영강의 윤슬, 장산의 숨결을 닮은 삶',
            'APEC 나루공원부터 단지를 거닐며 매 순간 느끼는 고요함',
            '67층에서 바라보는 광활한 리버뷰의 절대적 여유로움',
          ]
        },
      ],

commCats: [
        { cat: 'KIDS',    items: ['다함께돌봄센터', '공동육아시설', '키즈카페', '어린이집 (1F)'] },
        { cat: 'EDU',     items: ['비즈 & 스터디 라운지', '크리에이티브 스튜디오', '북라운지'] },
        { cat: 'SPORTS',  items: ['프리미어 골프클럽', '피트니스클럽', '리버뷰 아쿠아풀', '테라피 스파'] },
        { cat: 'CULTURE', items: ['컨시어지 라운지', '카페 라운지', '시그니처 살롱', '런드리카페 / 파티룸'] },
        { cat: 'FAMILY',  items: ['시니어 살롱', '게스트룸', '펫카페', '관리사무소 (1F)'] },
      ],

      systemItems: [
        { icon: '음식물쓰레기.png', label: '클린 시스템',        lead: '',              title: '음식물쓰레기 자동이송설비', desc: '주방 싱크대 옆 투입구를 통해 지하주차장 중앙 집하장까지 음식물쓰레기를 자동 이송합니다.' },
        { icon: 'iot.png',          label: '르엘 스마트홈 시스템', lead: '편리하고 똑똑한',  title: 'IoT 시스템 인프라 구축',   desc: '세대 내·외부에서 휴대폰·음성인식기 등으로 홈기기 예약 및 제어, 기상정보 확인, 외출모드 작동, 주차공간 확인, 쇼핑 등이 가능합니다. (음성인식 스피커 별매)' },
        { icon: '스마트패드.png',   label: '르엘 스마트홈 시스템', lead: '쾌적하고 건강한',  title: '스마트패스 시스템',        desc: '차량 주차부터 공동현관 출입, 승강기 자동호출까지 원패스로 가능해 편리합니다.' },
        { icon: '세대비상콜.png',   label: '르엘 시큐리티 시스템', lead: '빈틈 없이 안전한',  title: '세대 비상콜',              desc: '세대 내 비상상황 발생 시 방재실과의 양방향 통신으로 더욱 신속하게 대응합니다.' },
        { icon: '세대동체.png',     label: '르엘 시큐리티 시스템', lead: '빈틈 없이 안전한',  title: '세대 동체감지기',          desc: '세대 내 위험 상황이 발생하거나 외부인 출입이 감지될 경우 신속하게 통보합니다. (거실 설치)' },
        { icon: '주차관제.png',     label: '르엘 주차장 시스템',   lead: '효율적이고 편리한', title: '주차관제 · 차량도착알림',   desc: '등록된 차량만 단지 출입이 가능하며, 세대 내 월패드로 통보합니다.' },
        { icon: '사전등록.png',     label: '르엘 주차장 시스템',   lead: '효율적이고 편리한', title: '방문차량 사전등록',        desc: '월패드와 스마트폰으로 방문차량을 사전 등록해 빠르고 편리하게 주차장에 진입합니다.' },
      ],

      unitList: [
        { id: '84',   supply: 120, exclusive: '84.9280',  residential: '29.1141', other: '64.7223',  supplyArea: '114.0421', contract: '178.7644' },
        { id: '104A', supply: 162, exclusive: '104.8855', residential: '35.3015', other: '79.9315',  supplyArea: '140.1870', contract: '220.1185' },
        { id: '104B', supply: 240, exclusive: '104.6983', residential: '35.2834', other: '79.7888',  supplyArea: '139.9817', contract: '219.7705' },
        { id: '104C', supply: 120, exclusive: '104.6983', residential: '35.2834', other: '79.7888',  supplyArea: '139.9817', contract: '219.7705' },
        { id: '104D', supply: 42,  exclusive: '104.9523', residential: '35.6619', other: '79.9824',  supplyArea: '140.6142', contract: '220.5966' },
        { id: '125A', supply: 488, exclusive: '125.8735', residential: '44.9778', other: '95.9261',  supplyArea: '170.8513', contract: '266.7774' },
        { id: '125B', supply: 43,  exclusive: '125.6543', residential: '44.6916', other: '95.7590',  supplyArea: '170.3459', contract: '266.1049' },
        { id: '125C', supply: 43,  exclusive: '125.9550', residential: '44.7760', other: '95.9882',  supplyArea: '170.7310', contract: '266.7192' },
        { id: '125D', supply: 122, exclusive: '125.8735', residential: '44.9538', other: '95.9261',  supplyArea: '170.8273', contract: '266.7534' },
        { id: '154',  supply: 684, exclusive: '154.9326', residential: '52.9459', other: '118.0716', supplyArea: '207.8785', contract: '325.9501' },
        { id: '244',  supply: 6,   exclusive: '244.9791', residential: '88.5784', other: '186.6945', supplyArea: '333.5575', contract: '520.2520' },
      ],

      ovSlide: 0,
    }
  },
  mounted() {
    const v = this.$refs.heroVideo
    if (v) {
      v.muted = true
      const p = v.play()
      if (p && p.catch) p.catch(() => {})
    }
    this.startOvTimer()
    this.$nextTick(() => this.setupReveal())
  },
  beforeUnmount() {
    clearInterval(this._ovTimer)
    if (this._revealIO) this._revealIO.disconnect()
  },
  computed: {
    currentUnit() {
      return this.unitList.find(u => u.id === this.activeUnit) || this.unitList[0]
    }
  },
  methods: {
    openRegister() {
      window.dispatchEvent(new Event('open-register-popup'))
    },
    startOvTimer() {
      clearInterval(this._ovTimer)
      this._ovTimer = setInterval(() => {
        this.ovSlide = (this.ovSlide + 1) % 3
      }, 4000)
    },
    goOvSlide(i) {
      this.ovSlide = i
      this.startOvTimer()
    },
    nextOvSlide() {
      this.goOvSlide((this.ovSlide + 1) % 3)
    },
    prevOvSlide() {
      this.goOvSlide((this.ovSlide + 2) % 3)
    },
    onOvTouchStart(e) {
      this._ovTouchX = e.changedTouches[0].clientX
    },
    onOvTouchEnd(e) {
      const dx = e.changedTouches[0].clientX - (this._ovTouchX || 0)
      if (Math.abs(dx) < 40) return
      this.goOvSlide((this.ovSlide + (dx < 0 ? 1 : 2)) % 3)
    },
    unitImg(id, n) {
      try {
        return require('@/assets/unit/' + id + n + '.jpg')
      } catch (e) {
        return null
      }
    },
    assetImg(name) {
      try {
        return require('@/assets/' + name)
      } catch (e) {
        return null
      }
    },
    setupReveal() {
      if (typeof IntersectionObserver === 'undefined') return
      const sel = '.lp-eyebrow, .lp-section-title, .lp-gold-line, .lp-sec-sub, .ov-stats, .ov-spec, .loc-card, .plot-lead, .plot-fig, .comm-stats, .comm-lead, .comm-note, .comm-video, .comm-images, .comm-cat, .unit-tabs-wrap, .sys-card, .cta-desc, .cta-btn, .cta-note'
      const els = this.$el.querySelectorAll(sel)
      els.forEach(el => el.classList.add('reveal'))
      this._revealIO = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal-in')
            this._revealIO.unobserve(entry.target)
          }
        })
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' })
      els.forEach(el => this._revealIO.observe(el))
    }
  }
}
</script>

<style scoped>
/* ==================== ROOT ==================== */
.lp {
  background: var(--le-cream);
  color: var(--le-ink);
  font-family: var(--font-sans);
  letter-spacing: -0.01em;
  overflow-x: hidden;
}

.lp em {
  font-family: var(--font-serif-en);
  font-style: italic;
  font-weight: 400;
  color: var(--le-champagne-dark);
}

.lp strong { font-weight: 600; color: var(--le-noir); }

.lp-inner {
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 22px;
}
.lp-inner.narrow { max-width: 760px; }
.lp-inner.center { text-align: center; }

.lp-section {
  padding: 96px 0;
  position: relative;
}

.lp-eyebrow {
  display: block;
  font-family: var(--font-mono-disp);
  font-size: 11px;
  letter-spacing: 0.38em;
  font-weight: 500;
  color: var(--le-champagne-dark);
  margin-bottom: 22px;
}
.lp-eyebrow.light { color: var(--le-champagne); }

.lp-section-title {
  font-family: var(--font-sans);
  font-weight: 700;
  font-size: 30px;
  line-height: 1.4;
  color: var(--le-noir);
  letter-spacing: -0.02em;
  margin-bottom: 28px;
}
.lp-section-title em {
  font-family: var(--font-sans);
  font-weight: 700;
  font-style: normal;
  color: var(--le-champagne-dark);
}
.lp-section-title.white { color: var(--le-pearl); }
.lp-section-title.white em { color: var(--le-champagne-light); }
.lp-section-title.light { font-weight: 200; }

.lp-gold-line {
  width: 60px; height: 1px;
  background: linear-gradient(90deg, var(--le-champagne), rgba(201,169,107,0));
  margin: 0 0 40px;
}
.lp-gold-line.short { width: 36px; margin: 18px 0; }

/* ==================== HERO IMAGE ==================== */
.lp-hero-img {
  width: 100%;
  background: var(--le-noir);
  line-height: 0;
}
.lp-hero-img img {
  display: block;
  width: 100%;
  height: auto;
}
/* 히어로 영상: 원본 비율 유지하며 하단만 살짝 크롭 */
.lp-hero-video {
  overflow: hidden;
  line-height: 0;
  background: var(--le-noir);
}
.lp-hero-video video {
  display: block;
  width: 100%;
  height: auto;
  margin-bottom: -55%; /* 하단 크롭량 (숫자 키우면 더 많이 잘림) */
}

/* ==================== 섹션 헤더 (사업개요) ==================== */
.lp-sec-head {
  padding: 46px 0 30px;
  background: var(--le-cream);
  text-align: center;
}
.lp-sec-head .lp-eyebrow { margin-bottom: 12px; }
.lp-sec-head .lp-section-title {
  font-family: var(--font-sans);
  font-weight: 700;
  font-size: 26px;
  color: var(--le-noir);
  letter-spacing: -0.02em;
  margin-bottom: 18px;
}
.lp-sec-head .lp-gold-line { margin: 0 auto; }

.ov-stats {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 24px;
  margin: 0 0 14px;
}
.ov-stat { display: flex; align-items: baseline; gap: 5px; }
.ov-stat-num {
  font-family: var(--font-sans);
  font-size: 46px;
  font-weight: 500;
  line-height: 1;
  color: var(--le-noir);
  letter-spacing: -0.03em;
}
.ov-stat-unit {
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 700;
  color: var(--le-champagne-dark);
}
.ov-stat-div {
  align-self: center;
  width: 1px;
  height: 30px;
  background: var(--le-gold-line);
}
.lp-sec-sub {
  font-family: var(--font-sans);
  font-weight: 500;
  font-size: 15px;
  line-height: 1.6;
  color: var(--le-charcoal);
  letter-spacing: -0.01em;
  margin-bottom: 18px;
}

/* ==================== 조감도 롤링 배너 ==================== */
.ov-carousel-sec { background: var(--le-noir); }
.ov-carousel {
  position: relative;
  overflow: hidden;
  width: 100%;
  line-height: 0;
}
.ov-track {
  display: flex;
  width: 100%;
  transition: transform 0.7s cubic-bezier(0.22, 0.61, 0.36, 1);
}
.ov-slide { flex: 0 0 100%; width: 100%; }
.ov-slide img { display: block; width: 100%; height: auto; } /* 무크롭: 원본 전체 노출 */

.ov-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(11, 11, 15, 0.32);
  border: 1px solid rgba(201, 169, 107, 0.5);
  color: var(--le-champagne-light);
  cursor: pointer;
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
  transition: background 0.25s ease, border-color 0.25s ease;
}
.ov-arrow:hover { background: rgba(11, 11, 15, 0.6); border-color: var(--le-champagne); }
.ov-arrow svg { display: block; }
.ov-arrow-prev { left: 12px; }
.ov-arrow-next { right: 12px; }

.ov-counter {
  position: absolute;
  right: 14px;
  bottom: 12px;
  z-index: 2;
  display: flex;
  align-items: baseline;
  gap: 3px;
  padding: 6px 10px;
  line-height: 1;
  background: rgba(11, 11, 15, 0.4);
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
}
.ov-counter-cur {
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 700;
  color: var(--le-champagne-light);
}
.ov-counter-sep,
.ov-counter-total {
  font-family: var(--font-sans);
  font-size: 11px;
  font-weight: 500;
  color: rgba(244, 239, 230, 0.55);
}

/* ==================== 사업개요 스펙 (2칸) ==================== */
.lp-overview-table {
  background: var(--le-bone);
  padding: 40px 0 52px;
}
.ov-specs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1px;
  max-width: 680px;
  margin: 0 auto;
  background: var(--le-gold-line);
  border: 1px solid var(--le-gold-line);
}
.ov-spec {
  background: var(--le-cream);
  padding: 15px 18px;
  text-align: left;
}
.ov-spec-wide { grid-column: 1 / -1; }
.ov-spec dt {
  font-family: var(--font-sans);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--le-champagne-dark);
  margin-bottom: 6px;
}
.ov-spec dd {
  margin: 0;
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 500;
  color: var(--le-noir);
  line-height: 1.5;
}

@media (min-width: 768px) {
  .lp-sec-head { padding: 64px 0 40px; }
  .lp-sec-head .lp-section-title { font-size: 30px; }
  .ov-stat-num { font-size: 60px; }
  .ov-stat-unit { font-size: 16px; }
  .ov-stat-div { height: 40px; }
  .lp-sec-sub { font-size: 17px; }
  .ov-arrow { width: 48px; height: 48px; }
  .ov-spec { padding: 18px 22px; }
  .ov-spec dd { font-size: 15px; }
}

/* ==================== LOCATION & VALUE (프리미엄) ==================== */
.lp-location {
  background: var(--le-noir);
  padding: 60px 0 68px;
  position: relative;
}
.lp-location::before,
.lp-location::after {
  content: '';
  position: absolute;
  left: 0; right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--le-champagne), transparent);
  opacity: 0.3;
}
.lp-location::before { top: 0; }
.lp-location::after { bottom: 0; }
.lp-location .lp-gold-line { margin: 0 auto 34px; }

.loc-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
  text-align: left;
  margin-top: 8px;
}
.loc-card {
  padding: 24px 22px;
  border: 1px solid rgba(201, 169, 107, 0.22);
  background: linear-gradient(180deg, rgba(201, 169, 107, 0.06), rgba(201, 169, 107, 0));
}
.loc-card-head {
  display: flex;
  align-items: baseline;
  gap: 12px;
  margin-bottom: 10px;
}
.loc-num {
  font-family: var(--font-display, 'Italiana', serif);
  font-size: 26px;
  font-weight: 400;
  color: var(--le-champagne);
  line-height: 1;
}
.loc-tag {
  font-family: var(--font-mono-disp, 'Cinzel', serif);
  font-size: 10px;
  letter-spacing: 0.26em;
  font-weight: 500;
  color: rgba(201, 169, 107, 0.6);
}
.loc-en {
  font-family: var(--font-sans);
  font-size: 19px;
  font-weight: 700;
  letter-spacing: 0.01em;
  color: var(--le-pearl);
  margin-bottom: 12px;
}
.loc-line {
  width: 24px;
  height: 1px;
  background: var(--le-champagne);
  margin-bottom: 14px;
}
.loc-list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.loc-list li {
  position: relative;
  padding-left: 14px;
  font-family: var(--font-sans);
  font-size: 13.5px;
  font-weight: 400;
  line-height: 1.6;
  color: rgba(244, 239, 230, 0.72);
  letter-spacing: -0.01em;
}
.loc-list li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 8px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: var(--le-champagne);
}

@media (min-width: 768px) {
  .lp-location { padding: 88px 0 96px; }
  .loc-grid { grid-template-columns: 1fr 1fr; gap: 18px; }
  .loc-card { padding: 32px 30px; }
  .loc-en { font-size: 22px; }
  .loc-list li { font-size: 14.5px; }
}

/* ==================== MOTTO ==================== */
.lp-motto {
  position: relative;
  background: var(--le-noir, #0B0B0F);
  color: var(--le-pearl, #F4EFE6);
  padding: 140px 22px 0;
  overflow: hidden;
  text-align: center;
}
.motto-bg {
  position: absolute; inset: 0;
  background:
    radial-gradient(ellipse at 50% 50%, rgba(222,193,138,0.10), transparent 65%),
    linear-gradient(180deg, #1E140D 0%, #2A1C12 50%, #1E140D 100%);
  pointer-events: none;
}
.motto-bg::after {
  content: '';
  position: absolute; inset: 0;
  background-image:
    repeating-linear-gradient(90deg, rgba(255,255,255,0.012) 0 1px, transparent 1px 3px),
    repeating-linear-gradient(0deg,  rgba(255,255,255,0.012) 0 1px, transparent 1px 3px);
}
.motto-inner {
  position: relative;
  z-index: 1;
  max-width: 640px;
  margin: 0 auto;
}
.motto-ornament {
  display: flex; align-items: center; justify-content: center;
  gap: 14px;
  margin: 0 auto;
}
.motto-orn-line {
  display: block;
  width: 70px; height: 1px;
  background: linear-gradient(90deg, transparent, var(--le-champagne, #DEC18A), transparent);
}
.motto-orn-dot {
  width: 5px; height: 5px;
  border-radius: 50%;
  background: var(--le-champagne, #DEC18A);
  box-shadow: 0 0 12px rgba(222,193,138,0.7);
  transform: rotate(45deg);
  border-radius: 1px;
}
.motto-latin {
  font-family: var(--font-display, 'Italiana', 'Cormorant Garamond', serif);
  font-weight: 400;
  font-style: italic;
  font-size: clamp(40px, 10vw, 88px);
  line-height: 1.05;
  letter-spacing: 0.01em;
  margin: 48px 0 40px;
  background: linear-gradient(180deg, #F8F1E2 0%, #E7C994 55%, #B98F4E 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 0 0 40px rgba(222,193,138,0.18);
}
.motto-latin-word {
  display: inline-block;
}
.motto-latin-sep {
  display: inline-block;
  font-style: normal;
  color: var(--le-champagne, #DEC18A);
  -webkit-text-fill-color: var(--le-champagne, #DEC18A);
  padding: 0 0.35em;
  font-size: 0.7em;
  vertical-align: 0.15em;
  opacity: 0.85;
}
.motto-kr {
  font-family: var(--font-serif-kr, 'Noto Serif KR', serif);
  font-weight: 300;
  font-size: 16px;
  line-height: 2;
  letter-spacing: 0.32em;
  color: rgba(244,239,230,0.78);
  margin: 0 0 56px;
  padding-left: 0.32em;
}

/* ----- MOTTO entrance animation ----- */
.motto-anim {
  opacity: 0;
  transform: translateY(40px);
  filter: blur(8px);
  transition:
    opacity 1.1s cubic-bezier(0.22, 0.61, 0.36, 1),
    transform 1.2s cubic-bezier(0.22, 0.61, 0.36, 1),
    filter 1.1s cubic-bezier(0.22, 0.61, 0.36, 1);
  will-change: opacity, transform, filter;
}
.lp-motto.is-visible .motto-anim {
  opacity: 1;
  transform: translateY(0);
  filter: blur(0);
}
.motto-anim[data-i="0"] { transition-delay: 0.05s; transform: translateY(-20px); }
.lp-motto.is-visible .motto-anim[data-i="0"] { transform: translateY(0); }
.motto-anim[data-i="1"] { transition-delay: 0.25s; transform: translateY(50px) scale(0.96); }
.lp-motto.is-visible .motto-anim[data-i="1"] { transform: translateY(0) scale(1); }
.motto-anim[data-i="2"] { transition-delay: 0.65s; }
.motto-anim[data-i="3"] { transition-delay: 0.9s; transform: translateY(20px); }
.lp-motto.is-visible .motto-anim[data-i="3"] { transform: translateY(0); }

.motto-orn-line {
  transform-origin: center;
}
.lp-motto .motto-anim[data-i="0"] .motto-orn-line,
.lp-motto .motto-anim[data-i="3"] .motto-orn-line {
  transform: scaleX(0);
  transition: transform 1.1s cubic-bezier(0.22, 0.61, 0.36, 1);
  transition-delay: 0.15s;
}
.lp-motto.is-visible .motto-anim[data-i="3"] .motto-orn-line {
  transition-delay: 1.0s;
}
.lp-motto.is-visible .motto-anim[data-i="0"] .motto-orn-line,
.lp-motto.is-visible .motto-anim[data-i="3"] .motto-orn-line {
  transform: scaleX(1);
}

@media (prefers-reduced-motion: reduce) {
  .motto-anim,
  .lp-motto .motto-anim .motto-orn-line {
    opacity: 1 !important;
    transform: none !important;
    filter: none !important;
    transition: none !important;
  }
}

/* ==================== ULTIMATE 8 ==================== */
.lp-ultimate {
  background: var(--le-noir);
  padding: 120px 0;
  position: relative;
}
.lp-ultimate::before, .lp-ultimate::after {
  content: ''; position: absolute; left: 0; right: 0; height: 1px;
  background: linear-gradient(90deg, transparent, var(--le-champagne), transparent);
}
.lp-ultimate::before { top: 0; opacity: 0.3; }
.lp-ultimate::after { bottom: 0; opacity: 0.3; }

.ult-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0;
  margin-top: 14px;
  border-top: 1px solid rgba(201,169,107,0.18);
  border-left: 1px solid rgba(201,169,107,0.18);
}
.ult-card {
  padding: 24px 14px 26px;
  border-right: 1px solid rgba(201,169,107,0.18);
  border-bottom: 1px solid rgba(201,169,107,0.18);
  position: relative;
  display: flex;
  flex-direction: column;
}
.ult-card-head {
  display: flex; align-items: baseline; justify-content: space-between;
  margin-bottom: 14px;
}
.ult-num {
  font-family: var(--font-display);
  font-size: 32px;
  font-weight: 400;
  color: var(--le-champagne);
  line-height: 1;
}
.ult-tag {
  font-family: var(--font-mono-disp);
  font-size: 8px;
  letter-spacing: 0.3em;
  color: rgba(201,169,107,0.45);
  font-weight: 500;
}
.ult-title {
  font-family: var(--font-serif-kr);
  font-size: 17px;
  font-weight: 500;
  color: var(--le-pearl);
  margin-bottom: 4px;
  letter-spacing: -0.01em;
  line-height: 1.3;
}
.ult-en {
  font-family: var(--font-serif-en);
  font-size: 11px;
  font-style: italic;
  color: var(--le-champagne);
  margin-bottom: 12px;
  font-weight: 400;
  letter-spacing: 0.02em;
}
.ult-line {
  width: 20px; height: 1px;
  background: var(--le-champagne);
  margin-bottom: 12px;
}
.ult-desc {
  font-family: var(--font-serif-kr);
  font-weight: 300;
  font-size: 12px;
  line-height: 1.75;
  color: rgba(244,239,230,0.72);
  letter-spacing: -0.01em;
}
.ult-desc strong {
  color: var(--le-champagne-light);
  font-weight: 500;
}

/* ==================== PLOT PLAN ==================== */
.lp-plot {
  background: var(--le-bone, #EFE8DA);
  padding: 110px 0 120px;
}
.lp-plot .lp-gold-line {
  margin-left: auto;
  margin-right: auto;
}
.plot-lead {
  font-family: var(--font-serif-kr);
  font-size: 15px;
  font-weight: 300;
  line-height: 1.9;
  color: var(--le-ink);
  text-align: center;
  margin-top: 4px;
  margin-bottom: 36px;
}
.plot-lead strong {
  color: var(--le-champagne-dark, #A8884E);
  font-weight: 500;
}
.plot-fig {
  margin: 0;
  position: relative;
  padding: 14px;
  background: linear-gradient(180deg, #F6EFE0 0%, #ECE1C8 100%);
  border: 1px solid rgba(201, 169, 107, 0.35);
  box-shadow:
    0 0 0 1px rgba(255,255,255,0.4) inset,
    0 24px 50px -20px rgba(11, 11, 15, 0.18);
}
.plot-fig::before,
.plot-fig::after {
  content: '';
  position: absolute;
  width: 14px; height: 14px;
  border: 1px solid var(--le-champagne, #C9A96B);
  opacity: 0.7;
}
.plot-fig::before { top: 4px; left: 4px; border-right: none; border-bottom: none; }
.plot-fig::after  { bottom: 4px; right: 4px; border-left: none; border-top: none; }
.plot-img {
  display: block;
  width: 100%;
  height: auto;
}
.plot-img + .plot-img { margin-top: 14px; }
.plot-cap {
  margin-top: 14px;
  font-family: var(--font-sans);
  font-size: 11px;
  color: var(--le-warm-grey, #7A6E5A);
  text-align: center;
  letter-spacing: 0.02em;
}

/* ==================== COMMUNITY (Salon de LEEL) ==================== */
.lp-community {
  background: var(--le-noir);
  padding: 60px 0 68px;
  position: relative;
}
.lp-community::before,
.lp-community::after {
  content: '';
  position: absolute;
  left: 0; right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--le-champagne), transparent);
  opacity: 0.3;
}
.lp-community::before { top: 0; }
.lp-community::after { bottom: 0; }
.lp-community .lp-gold-line { margin: 0 auto 22px; }

.comm-stats {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 26px;
  margin-bottom: 18px;
}
.comm-stat { display: flex; align-items: baseline; gap: 5px; }
.comm-stat-num {
  font-family: var(--font-sans);
  font-size: 40px;
  font-weight: 300;
  line-height: 1;
  color: var(--le-pearl);
  letter-spacing: -0.03em;
}
.comm-stat-unit {
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 700;
  color: var(--le-champagne);
}
.comm-stat-div {
  align-self: center;
  width: 1px; height: 30px;
  background: rgba(201, 169, 107, 0.4);
}
.comm-lead {
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 400;
  line-height: 1.8;
  color: rgba(244, 239, 230, 0.72);
  max-width: 560px;
  margin: 0 auto 12px;
  letter-spacing: -0.01em;
}
.comm-note {
  font-family: var(--font-mono-disp, 'Cinzel', serif);
  font-size: 11px;
  letter-spacing: 0.24em;
  color: rgba(201, 169, 107, 0.7);
}

/* 영상 */
.comm-video {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  margin-top: 36px;
  background: #000;
  border: 1px solid rgba(201, 169, 107, 0.3);
}
.comm-video iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

/* 이미지 */
.comm-images {
  margin-top: 24px;
  line-height: 0;
}
.comm-images img {
  display: block;
  width: 100%;
  height: auto;
}
.comm-images img + img { margin-top: 4px; }

/* 시설 카테고리 */
.comm-cats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1px;
  margin-top: 40px;
  background: rgba(201, 169, 107, 0.18);
  border: 1px solid rgba(201, 169, 107, 0.18);
  text-align: left;
}
.comm-cat {
  background: var(--le-noir);
  padding: 22px 20px;
}
.comm-cat-wide { grid-column: 1 / -1; }
.comm-cat-name {
  display: block;
  font-family: var(--font-mono-disp, 'Cinzel', serif);
  font-size: 13px;
  letter-spacing: 0.22em;
  font-weight: 600;
  color: var(--le-champagne);
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid rgba(201, 169, 107, 0.2);
}
.comm-cat-list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.comm-cat-list li {
  font-family: var(--font-sans);
  font-size: 13.5px;
  font-weight: 400;
  color: rgba(244, 239, 230, 0.72);
  letter-spacing: -0.01em;
}

/* ==================== UNIT (세대안내) ==================== */
.lp-unit {
  background: var(--le-pearl);
  padding: 64px 0 72px;
}
.lp-unit .lp-gold-line { margin: 0 auto 28px; }

/* 타입 탭 (가로 스크롤) */
.unit-tabs-wrap {
  margin: 0 -22px 24px;
  padding: 0 22px 4px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.unit-tabs-wrap::-webkit-scrollbar { display: none; }
.unit-tabs {
  display: inline-flex;
  gap: 8px;
  padding-right: 22px;
}
.unit-tab {
  flex-shrink: 0;
  min-width: 60px;
  padding: 11px 16px;
  background: transparent;
  border: 1px solid var(--le-gold-line);
  border-radius: 999px;
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 700;
  color: var(--le-warm-grey);
  letter-spacing: -0.01em;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.3s cubic-bezier(0.22, 0.61, 0.36, 1);
}
.unit-tab:hover { border-color: var(--le-champagne); color: var(--le-champagne-dark); }
.unit-tab.active {
  background: var(--le-noir);
  border-color: var(--le-noir);
  color: var(--le-champagne);
  box-shadow: 0 8px 20px -10px rgba(11, 11, 15, 0.4);
}

/* 서브 배너 */
.unit-detail { text-align: left; }
.unit-banner {
  background: var(--le-noir);
  padding: 24px 22px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.unit-banner-head {
  display: flex;
  align-items: baseline;
  gap: 12px;
}
.unit-area {
  font-family: var(--font-sans);
  font-size: 40px;
  font-weight: 300;
  line-height: 1;
  color: var(--le-pearl);
  letter-spacing: -0.03em;
}
.unit-area-unit {
  font-size: 16px;
  font-weight: 500;
  color: var(--le-champagne);
  margin-left: 4px;
}
.unit-badge {
  font-family: var(--font-sans);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--le-noir);
  background: var(--le-champagne);
  padding: 4px 10px;
}
.unit-supply {
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 400;
  color: rgba(244, 239, 230, 0.7);
}
.unit-supply strong { color: var(--le-champagne-light); font-weight: 700; }

/* 면적 정보 */
.unit-specs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1px;
  background: var(--le-gold-line);
  border: 1px solid var(--le-gold-line);
  border-top: none;
}
.unit-spec {
  background: var(--le-cream);
  padding: 14px 16px;
}
.unit-spec dt {
  font-family: var(--font-sans);
  font-size: 11px;
  font-weight: 600;
  color: var(--le-champagne-dark);
  margin-bottom: 5px;
}
.unit-spec dd {
  margin: 0;
  font-family: var(--font-sans);
  font-size: 15px;
  font-weight: 600;
  color: var(--le-noir);
}
.unit-spec-total { grid-column: 1 / -1; background: var(--le-bone); }
.unit-spec-total dd { color: var(--le-champagne-dark); }

/* 평면 이미지 */
.unit-images {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
}
.unit-img-slot {
  width: 100%;
  background: var(--le-cream);
  border: 1px solid var(--le-gold-line);
}
.unit-img {
  display: block;
  width: 100%;
  height: auto;
}
.unit-img-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 220px;
  background:
    repeating-linear-gradient(45deg, rgba(201, 169, 107, 0.05) 0 10px, transparent 10px 20px),
    var(--le-cream);
}
.unit-img-empty-id {
  font-family: var(--font-sans);
  font-size: 20px;
  font-weight: 700;
  color: var(--le-champagne-dark);
}
.unit-img-empty-sub {
  font-family: var(--font-sans);
  font-size: 12px;
  font-weight: 500;
  color: var(--le-warm-grey);
}

.unit-fade-enter-active,
.unit-fade-leave-active {
  transition: opacity 0.3s ease;
}
.unit-fade-enter-from,
.unit-fade-leave-to {
  opacity: 0;
}

@media (min-width: 768px) {
  .lp-unit { padding: 90px 0 100px; }
  .unit-area { font-size: 52px; }
  .unit-banner { padding: 30px 28px; }
  .unit-spec { padding: 16px 20px; }
  .unit-spec dd { font-size: 16px; }
  .unit-images { flex-direction: row; }
  .unit-img-slot { flex: 1; }
}

/* ==================== SYSTEM (시스템) ==================== */
.lp-system {
  background: var(--le-bone);
  padding: 60px 0 68px;
}
.lp-system .lp-gold-line { margin: 0 auto 28px; }
.sys-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
  margin-top: 8px;
  text-align: left;
}
.sys-card {
  display: flex;
  align-items: center;
  gap: 16px;
  background: var(--le-cream);
  border: 1px solid var(--le-gold-line);
  padding: 18px;
}
.sys-icon {
  flex-shrink: 0;
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sys-icon img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.sys-body { flex: 1; min-width: 0; }
.sys-label {
  display: block;
  font-family: var(--font-sans);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--le-champagne-dark);
  margin-bottom: 6px;
}
.sys-title {
  font-family: var(--font-sans);
  font-size: 17px;
  font-weight: 700;
  color: var(--le-noir);
  letter-spacing: -0.01em;
  line-height: 1.3;
  margin-bottom: 8px;
}
.sys-lead {
  display: block;
  font-family: var(--font-sans);
  font-size: 12px;
  font-weight: 400;
  color: var(--le-warm-grey);
  margin-bottom: 2px;
}
.sys-desc {
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 400;
  line-height: 1.65;
  color: var(--le-graphite);
  letter-spacing: -0.01em;
}
@media (min-width: 768px) {
  .lp-system { padding: 88px 0 96px; }
  .sys-grid { grid-template-columns: 1fr 1fr; gap: 16px; }
  .sys-icon { width: 72px; height: 72px; }
  .sys-title { font-size: 18px; }
}

/* ==================== CTA ==================== */
.lp-cta {
  background: var(--le-noir);
  color: var(--le-pearl);
  padding: 110px 0 130px;
  position: relative;
  overflow: hidden;
}
.lp-cta::before {
  content: '';
  position: absolute; inset: 0;
  background:
    radial-gradient(ellipse at center, rgba(201,169,107,0.12), transparent 60%);
  pointer-events: none;
}
.lp-cta .lp-inner { position: relative; z-index: 2; }
.lp-cta .lp-gold-line { margin-left: auto; margin-right: auto; }
.cta-desc {
  font-family: var(--font-serif-kr);
  font-weight: 300;
  font-size: 16px;
  line-height: 2;
  color: rgba(244,239,230,0.78);
  margin-bottom: 38px;
}
.cta-desc strong {
  color: var(--le-champagne-light);
  font-weight: 500;
}
.cta-btn {
  background: transparent;
  border: 1px solid var(--le-champagne);
  color: var(--le-pearl);
  padding: 22px 30px;
  font-family: inherit;
  cursor: pointer;
  width: 100%;
  max-width: 380px;
  margin: 0 auto;
  display: flex; flex-direction: column; align-items: center; gap: 6px;
  position: relative;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  overflow: hidden;
}
.cta-btn::before {
  content: '';
  position: absolute; inset: 0;
  background: linear-gradient(135deg, var(--le-champagne), var(--le-champagne-dark));
  transform: translateY(101%);
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 0;
}
.cta-btn:hover::before { transform: translateY(0); }
.cta-btn > * { position: relative; z-index: 1; }
.cta-btn:hover { color: var(--le-noir); border-color: var(--le-champagne); }
.cta-btn-en {
  font-family: var(--font-mono-disp);
  font-size: 11px;
  letter-spacing: 0.4em;
  color: var(--le-champagne);
  font-weight: 500;
  transition: color 0.4s;
}
.cta-btn:hover .cta-btn-en { color: var(--le-noir); }
.cta-btn-kr {
  font-family: var(--font-serif-kr);
  font-size: 17px;
  font-weight: 500;
  letter-spacing: 0.04em;
}
.cta-btn-arrow {
  font-family: var(--font-serif-en);
  font-size: 18px;
  margin-top: 4px;
  color: var(--le-champagne);
  transition: all 0.4s;
}
.cta-btn:hover .cta-btn-arrow { color: var(--le-noir); transform: translateX(4px); }

.cta-note {
  margin-top: 36px;
  font-family: var(--font-serif-kr);
  font-size: 11px;
  color: rgba(244,239,230,0.4);
  line-height: 1.8;
  font-weight: 300;
}

/* ==================== RESPONSIVE (Tablet+) ==================== */
@media (min-width: 768px) {
  .lp-inner { padding: 0 40px; }
  .lp-section { padding: 130px 0; }

  .lp-section-title { font-size: 44px; margin-bottom: 36px; }
  .lp-eyebrow { font-size: 12px; margin-bottom: 28px; }
  .lp-gold-line { width: 80px; margin-bottom: 56px; }

  .lp-motto { padding: 180px 22px 0; }
  .motto-eyebrow { font-size: 13px; margin-bottom: 72px; }
  .motto-orn-line { width: 110px; }
  .motto-kr { font-size: 19px; }

  .ult-grid {
    grid-template-columns: repeat(2, 1fr);
    border-left: 1px solid rgba(201,169,107,0.18);
  }
  .ult-card {
    border-right: 1px solid rgba(201,169,107,0.18);
    padding: 50px 32px 56px;
  }
  .ult-num { font-size: 56px; }
  .ult-title { font-size: 28px; }

  .lp-community { padding: 88px 0 96px; }
  .comm-stat-num { font-size: 56px; }
  .comm-stat-unit { font-size: 16px; }
  .comm-lead { font-size: 15px; }
}

@media (min-width: 1024px) {
  .lp-section { padding: 160px 0; }
  .lp-section-title { font-size: 52px; }
  .ult-grid { grid-template-columns: repeat(4, 1fr); }
}

/* ==================== SCROLL REVEAL ==================== */
.reveal {
  opacity: 0;
  transform: translateY(26px);
  transition:
    opacity 0.7s cubic-bezier(0.22, 0.61, 0.36, 1),
    transform 0.7s cubic-bezier(0.22, 0.61, 0.36, 1);
  will-change: opacity, transform;
}
.reveal-in {
  opacity: 1;
  transform: none;
}
/* 그룹 스태거 (카드가 순차로 휙휙) */
.loc-card:nth-child(2) { transition-delay: 0.08s; }
.loc-card:nth-child(3) { transition-delay: 0.16s; }
.loc-card:nth-child(4) { transition-delay: 0.24s; }
.comm-cat:nth-child(2) { transition-delay: 0.06s; }
.comm-cat:nth-child(3) { transition-delay: 0.12s; }
.comm-cat:nth-child(4) { transition-delay: 0.18s; }
.comm-cat:nth-child(5) { transition-delay: 0.24s; }
.sys-card:nth-child(2) { transition-delay: 0.05s; }
.sys-card:nth-child(3) { transition-delay: 0.10s; }
.sys-card:nth-child(4) { transition-delay: 0.15s; }
.sys-card:nth-child(5) { transition-delay: 0.20s; }
.sys-card:nth-child(6) { transition-delay: 0.25s; }
.sys-card:nth-child(7) { transition-delay: 0.30s; }
.ov-spec:nth-child(2) { transition-delay: 0.05s; }
.ov-spec:nth-child(3) { transition-delay: 0.10s; }
.ov-spec:nth-child(4) { transition-delay: 0.15s; }
.ov-spec:nth-child(5) { transition-delay: 0.20s; }
.ov-spec:nth-child(6) { transition-delay: 0.25s; }
.ov-spec:nth-child(7) { transition-delay: 0.30s; }
@media (prefers-reduced-motion: reduce) {
  .reveal { opacity: 1 !important; transform: none !important; transition: none !important; }
}
</style>
